const tr = {
  dashboard: {
    attributes: {
      corporation: 'Empresa',
      doctor: 'Médico',
      attendant: 'Atendente',
      ignore_doctor: 'Desconsiderar Médico',
      specialty: 'Especialidade',
      category: 'Categoria',
      users: 'Usuários',
      type: 'Tipo',
      total: 'Total',
      unknown: 'Desconhecido',
      appointments: 'Consultas',
      appointment: 'Consulta',
      users_by_month: 'Vínculo de Colaboradores',
      users_by_month_description:
        'Vínculo de colaboradores a uma empresa num determinado período feito pelos próprios gestores ou na tela de Empresa (Ligamento / desligamento de colaboradores)',
      packages_by_month: 'Vínculo de Adicionais',
      packages_by_month_description:
        'Vínculo de adicionais a um colaborador de uma empresa num determinado período feito pelos próprios gestores ou na tela de Empresa (Ligamento / desligamento de adicionais); * CUMULATIVO: Desconsidera adicionais deletados depois da data final para adicionais criados antes da mesma;',
      packages_specialty_by_month: 'Vínculo de Adicionais (Especialista)',
      packages_specialty_by_month_description:
        'Vínculo de adicionais de médico especialista a um colaborador de uma empresa num determinado período feito pelos próprios gestores ou na tela de Empresa (Ligamento / desligamento de adicionais de médico especialista); * CUMULATIVO: Desconsidera adicionais deletados depois da data final para adicionais criados antes da mesma;',
      sales: 'Relatório de Vendas',
      SIDMedicalAppointmentsReports: 'Relatório de consultas realizadas',
      SIDMedicalAppointmentsReportsSubTitle:
        'Relatório de consultas realizadas por empresa entre um determinado período de tempo.',
      appointments_by_month: 'Consultas no mês',
      appointments_in_the_period: 'Consultas no período',
      appointments_specialty_by_month: 'Consultas por Especialista no mês',
      appointments_specialty_in_the_period:
        'Consultas por Especialista no período',
      appointments_category_by_month: 'Consultas por Categoria no mês',
      appointments_category_in_the_period: 'Consultas por Categoria no período',
      appointments_per_day: 'Consultas por dia',
      count_users: 'Total de usuários',
      count_appointments: 'Total de Consultas',
      count_appointments_request: 'Total de pressionamentos médicos',
      count_appointments_request_created_at:
        'Total de pressionamentos médicos (considera sempre o período com base na data de criação)',
      count_users_by_month: 'Total de usuários mensalmente',
      count_new_users_by_month: 'Novos usuários mensalmente',
      count_users_by_platform: 'Usuários por plataforma',
      count_packages_by_specialty: 'Por especialidade',
      count_corporations: 'Total de empresas',
      count_medical_appointments_by_month: 'Total de consultas mensalmente',
      download_csv: 'Baixar em planilha CSV',
      consider_only_for_created_at:
        '(considera sempre o período com base na data de criação)',
      with_specialty: 'Consultas COM especialidade',
      without_specialty: 'Consultas SEM especialidade',
      attendant_delay: 'Tempo para início da triagem',
      attendant_duration: 'Duração da triagem',
      doctor_delay: 'Tempo para início da consulta',
      doctor_duration: 'Duração da consulta',
      created_at: 'Solicitação médica',
      attendant_init_at: 'Início da triagem',
      attendant_end_at: 'Fim da triagem',
      doctor_init_at: 'Início da consulta',
      doctor_end_at: 'Fim da consulta',
      total_duration: 'Duração da jornada',
      user_name: 'Paciente',
      medical_appointments_time: 'Tempo médio de cada consulta',
      appointments_duration_total: 'Tempo médio da jornada do cliente',
      schedule_appointment_at: 'Data do agendamento',
      date_init: 'Data de início',
      date_end: 'Data de fim',
      dateType: 'Considerar período',
      to: 'a',
      view: 'Visualizar',
      accident_reports: 'Relatório de Sinistralidade',
      accident_reports_description:
        'Relatório de consultas realizadas por empresa entre um determinado período de tempo.',
      appointment_rating: 'Avaliação das Consultas',
      active_clients: 'Usuários Ativos',
      ids_integration: 'Integração IDS',
      logs_reports: 'Relatório de Logs',
      show_log: 'Vizualizando log',
    },
    extras: {},
    tabs: {
      users: 'Usuários',
      appointments: 'Consultas Médicas',
      appointmentsTime: 'Tempo de Consultas',
      packages: 'Adicionais',
      corporations: 'Empresas',
    },
  },
};

export default tr;
